// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"f1e5ff04","58":"33f455ba","226":"d78b3e09","399":"cdc84124","427":"7606b45f","505":"6b5b656c","576":"93b177a5","660":"590b8865","681":"3487accf","752":"5f901d03","875":"e4b2077a"}[chunkId] + ".chunk.js";
};